import Axios from "@/api/baseApi";

export default {
  add(form) {
    return Axios.put(`/api-registration/v1/piglet-registration`, form);
  },
  exist(pigStyId, calendarWeekId) {
    return Axios.get(`/api-registration/v1/piglet-registration/exist/${pigStyId}?calendarWeekId=${calendarWeekId}`);
  }
}

